<template>
  <v-expansion-panel>
    <v-expansion-panel-header>Owners</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row>
        <v-col cols="12" style="justify-items: flex-end;">
          <v-switch
            v-model="model.ownersExclude"
            hide-details
            color="orange darken-3"
            label="Exclude mode"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          v-for="owner in owners"
          :key="`iko${owner}`"
          cols="12"
          md="2"
          sm="2"
        >
          <v-checkbox
            v-model="model.owners"
            :value="owner"
            :label="`${owner}`"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-owners-panel",
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      owners: RedactorUtils.getMapKinds()
        .map(m => m.code)
        .sort((a, b) => a - b)
    };
  }
};
</script>
